import { useEffect } from 'react';
import { useStore } from 'react-redux';

import type { Reducer } from 'redux';

import { useAppDispatch } from './use-app-dispatch';

interface DynamicModuleReducersConfig {
    reducers: ReducersList;
    needRemoveAfterUnmount?: boolean;
}

export type ReducersList = {
    [name in AppStateSchemaKey]?: Reducer<NonNullable<AppStateSchema[name]>>;
};

export function useDynamicReducersLoader(config: DynamicModuleReducersConfig) {
    const { reducers, needRemoveAfterUnmount = true } = config;

    const store = useStore() as ReduxStoreWithReducerManager;
    const dispatch = useAppDispatch();

    useEffect(() => {
        const mountedReducerKeys = Object.keys(
            store.reducerManager.getReducerMap(),
        );
        const reducersAsArray = Object.entries(reducers);

        reducersAsArray.forEach(([key, reducer]) => {
            const isMounted = mountedReducerKeys.includes(key);

            if (!isMounted) {
                store.reducerManager.add(key as AppStateSchemaKey, reducer);
                dispatch({ type: `@INIT ${key} reducer` });
            }
        });

        return () => {
            if (needRemoveAfterUnmount) {
                reducersAsArray.forEach(([key]) => {
                    store.reducerManager.remove(
                        key as AppStateSchemaOptionsKey,
                    );
                    dispatch({ type: `@DESTROY ${key} reducer` });
                });
            }
        };
        // eslint-disable-next-line
    }, []);
}
